module.exports = __webpack_public_path__ + "img/bus-trip.846dd88f.svg";